<template>
    <div>
        <!-- main page -->
        <div class="vx-row mb-12">
            <vs-button v-if="checkQty==true" v-on:click="SubmitApproval()" color="primary">Submit</vs-button>
            <vs-button v-if="checkQty==false" v-on:click="CheckQuantity()" color="warning">Check</vs-button>
        </div>
        <div class="vx-row mb-12">
            <vs-alert color="warning" title="Warning" :active.sync="checkQtyError" class="mt-3" closable icon-pack="feather" close-icon="icon-x">
                <p v-html="checkQtyMessage"></p>
            </vs-alert>
        </div>
        <div class="vx-row mb-12">
            <div v-bind:class="[detailHide]">
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">{{this.dataEnd==0 ? 0: (this.limitShow * (this.isActive - 1) + 1)}} - {{this.limitShow * (this.isActive - 1) + dataEnd}} of {{this.recordsTotal}}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu>                
                                <vs-dropdown-item v-for="item in limits" v-bind:key="item" @click="changeLimit(item)">
                                    <span>{{item}}</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                    <div class="mx-auto"></div>
                    <div class="vx-col sm:w-1/3 w-full">
                        <div class="flex flex-wrap items-center justify-between">
                            <vs-input class="mb-4 md:mb-0 mr-4 w-full" v-model="search" placeholder="Search by : Reservation Code" />
                        </div>
                    </div>
                </div>

                <vs-table :data="dataReservation" stripe border>
                    <template slot="thead">
                        <vs-th>
                            <div class="vx-row mb-12">
                                <div class="vx-col">
                                    <vs-checkbox v-on:click="checkAllApproval('approve')" v-model="approveAll">Approve</vs-checkbox>
                                </div>
                                <div class="vx-col">
                                    <vs-checkbox class="vs-checkbox-warning" v-on:click="checkAllApproval('reject')" v-model="rejectAll">Reject</vs-checkbox>
                                </div>
                            </div>
                        </vs-th>
                        <vs-th>Reservation</vs-th>
                        <vs-th>Customer</vs-th>
                        <vs-th>Line</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="index" v-for="(dt, index) in data">
                            <vs-td>
                                <div class="vx-row mb-4">
                                    <div class="vx-col">
                                        <vs-checkbox :checked="approved.includes(dt.Code)" v-on:click="checkApproval(dt.Code, 'approve')">Approve</vs-checkbox>
                                    </div>
                                    <div class="vx-col">
                                        <vs-checkbox class="vs-checkbox-warning" :checked="rejected.includes(dt.Code)" v-on:click="checkApproval(dt.Code, 'reject')">Reject</vs-checkbox>
                                    </div>
                                </div>
                                <div class="vx-col">
                                    <vs-input class="" v-model="dt.ApprovalRemark" :key="dt.Code" @change="updateRemark(dt.Code, $event)" placeholder="Keterangan" />
                                </div>
                            </vs-td>
                            <vs-td>
                                Code : {{dt.Code}} <br>
                                Notes : {{dt.Notes}} <br>
                                Total Line : {{dt.ReservationLine.length}}
                            </vs-td>
                            <vs-td>
                                Category : {{dt.Customer.CustomerCategory.Name}} <br>
                                Code : {{dt.Customer.Code}} <br>
                                Name : {{dt.Customer.Name}} <br>
                            </vs-td>
                            <vs-td>
                                <span :key="indexItem" v-for="(item, indexItem) in dt.ReservationLine">
                                    {{item.ItemCode}} - {{item.ItemName}} ({{item.Quantity}} {{item.ItemUnit}}) <br>
                                </span>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
        
                <vs-pagination style="padding-top:5px" :total="maxPage" v-model="currentPage" :prev-icon="$vs.rtl ? 'arrow_forward' : 'arrow_back'" :next-icon="$vs.rtl ? 'arrow_back' : 'arrow_forward'"/>
            </div>
        </div>
    </div>
</template>


<script>
import moment from 'moment'

export default {
    components: {
        // 
    },
    props: 
        ["territory", "startDate", "endDate"],
        data() {
            return {
                dataReservation: [],
                salesOrderCode: "",
                selectedSO: [{}],

                approved: [],
                approveAll: false,
                rejected: [],
                rejectAll: false,
                remark: [],
                remarkCode: [],

                checkQty: false,
                checkQtyError: false,
                checkQtyMessage: "",

                limits: [10, 25, 50, 100, "All"],
                limitShow: 10,
                drawData: 0,
                isActive: 1,
                modelCheck: [],
                search: "",
                detailShow: "core vx-col md:w-1/2 w-full mb-base ",
                detailHide: "core vx-col md:w-1/1 w-full mb-base ",
                detail: false,
                recordsTotal: 0,
                maxPage: 2,
                dataEnd: 0,
            };
        },
    watch: {
        territory: function() {
            this.getData();
        },
        search: function() {
            this.getData();
        },
        startDate: function() {
            this.getData();
        },
        endDate: function() {
            this.getData();
        }
    },
    mounted() {
        // 
    },
    computed: {
        currentPage: {
            get() {
                return 1;
            },
            set(page) {
                this.page(page);
            }
        }
    },
    methods: {
        dateFormat(date) {
            if (date) {
                return moment(String(date)).utcOffset(0).format('MM/DD/YYYY hh:mm')
            }
        },

        scrollToTop() {
            window.scrollTo(0,0);
        },

        closeDetail() {
            this.detail = false;
        },

        checkApproval(reservationCode, action) {
            if(action == 'approve') {
                if (this.approved.includes(reservationCode)) {
                    this.approved.splice(this.approved.indexOf(reservationCode), 1); // unchecked approve
                } else {
                    this.approved.push(reservationCode); // checked approve
                    this.rejected = this.rejected.filter(value => value !== reservationCode) // unchecked reject
                }
            } else if(action == 'reject') {
                if (this.rejected.includes(reservationCode)) {
                    this.rejected.splice(this.rejected.indexOf(reservationCode), 1); // unchecked reject
                } else {
                    this.rejected.push(reservationCode); // checked reject
                    this.approved = this.approved.filter(value => value !== reservationCode) // unchecked approve
                }
            }
        },

        checkAllApproval(action) {
            if(action == 'approve') {
                this.rejectAll = false;
                if (this.approveAll == false) {
                    for (var i = 0; i < this.dataReservation.length; i++) {
                        if (this.approved.includes(this.dataReservation[i].Code)) {
                            //
                        } else {
                            this.approved.push(this.dataReservation[i].Code);
                            this.rejected.splice(this.approved.indexOf(i), 1); // unchecked reject
                        }
                    }
                } else {
                    for (var j = 0; j < this.dataReservation.length; j++) {
                        this.approved.splice(this.approved.indexOf(this.dataReservation[j].id), 1);
                    }
                }
            } else if(action == 'reject') {
                this.approveAll = false;
                if (this.rejectAll == false) {
                    for (var k = 0; k < this.dataReservation.length; k++) {
                        if (this.rejected.includes(this.dataReservation[k].Code)) {
                            //
                        } else {
                            this.rejected.push(this.dataReservation[k].Code);
                            this.approved.splice(this.rejected.indexOf(k), 1); // unchecked approve
                        }
                    }
                } else {
                    for (var l = 0; l < this.dataReservation.length; l++) {
                        this.rejected.splice(this.rejected.indexOf(this.dataReservation[l].id), 1);
                    }
                }
            }
        },

        updateRemark(reservationCode, event) {
            if (this.remarkCode.includes(reservationCode)) {
                const idx = this.remarkCode.indexOf(reservationCode)
                this.remark.splice(idx, 0, event.target.value);
            } else {
                this.remarkCode.push(reservationCode);
                this.remark.push(event.target.value);
            }
            // console.log(this.remarkCode, this.remark);
        },

        page(page) {
            this.getData(page);
            return page;
        },

        changeLimit(limit) {
            this.limitShow = limit;
            this.getData(this.isActive);
        },

        getData(page = 1) {
            this.isActive = page;
            this.$vs.loading();

            this.$http.get("/api/v1/reservation", {
                params: {
                    territory_code: this.territory,
                    start_created_at: this.startDate,
                    end_created_at: this.endDate,
                    approval_status: 0,
                    search: this.search,
                    limit: this.limitShow,
                    offset: this.limitShow * (page - 1)
                }
            }).then(resp => {
                // console.log(resp.data);
                if (resp.code == 200) {
                    this.drawData = this.drawData + 1;
                    this.dataReservation = resp.data.Reservations;
                    this.recordsTotal = resp.data.RecordsTotal;
                    this.maxPage = Math.ceil(this.recordsTotal / this.limitShow);
                    this.dataEnd = resp.data.ResultsTotal;
                    this.checkedAll = false;
                } else {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: resp.message,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle"
                    });
                }
                this.$vs.loading.close();
            });
        },
        CheckQuantity() {
            if(this.approved.length == 0 && this.rejected.length == 0 ) {
                this.$vs.notify({
                    title: "Error",
                    text: "Please select reservation first",
                    color: "danger",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-check"
                });
                return true;
            }
            
            this.$vs.loading();       
            this.$http
                .post("/api/v1/reservation/check-approval-by-code", {
                    approved_reservation_codes: this.approved,
                    rejected_reservation_codes: this.rejected,
                    remarks: this.remark,
                    remark_codes: this.remarkCode,
                })
                .then(resp => {
                    if (resp.code == 200) {
                        this.$vs.notify({
                            title: "Success",
                            text: resp.message,
                            color: "success",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-check"
                        });
                        if (resp.data.code==1) {
                            this.checkQty = true;
                            this.approveAll = false;
                            this.rejectAll = false;
                        } else {
                            var message = "";
                            var checkQuantityItems = resp.data.items
                            for (var i = 0; i < checkQuantityItems.length; i++) {
                                if (checkQuantityItems[i].qty_req > checkQuantityItems[i].qty_adj) {
                                    message += "Item "+checkQuantityItems[i].item_code+" exceed max quantity ("+checkQuantityItems[i].qty_adj+").";
                                    message += " Check following reservation code : "+checkQuantityItems[i].reservation_code;
                                    message += "<br>";
                                }
                            }
                            this.checkQtyError = true;
                            this.checkQtyMessage = message;
                            this.checkQty = false;
                        }
                        this.getData();
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle"
                        });
                        this.checkQty = false;
                    }
                    this.$vs.loading.close();
            });
        },
        SubmitApproval() {
            if(this.approved.length == 0 && this.rejected.length == 0 ) {
                this.$vs.notify({
                    title: "Error",
                    text: "Please select reservation first",
                    color: "danger",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-check"
                });
                return true;
            }
            
            this.$vs.loading();       
            this.$http
                .post("/api/v1/reservation/approval-by-code", {
                    approved_reservation_codes: this.approved,
                    rejected_reservation_codes: this.rejected,
                    remarks: this.remark,
                    remark_codes: this.remarkCode,
                })
                .then(resp => {
                    if (resp.code == 200) {
                        this.$vs.notify({
                            title: "Success",
                            text: "",
                            color: "success",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-check"
                        });
                        this.getData();
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle"
                        });
                    }
                    this.$vs.loading.close();
            });
            this.approveAll = false;
            this.rejectAll = false;
            this.checkQty = false;
        },
    }
};
</script>

<style>
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}
</style>